/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Line_Down_TitleInputs */



/**
* | output |
* | --- |
* | "Move Down One Line" |
*
* @param {Position_Line_Down_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_line_down_title = /** @type {((inputs?: Position_Line_Down_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Line_Down_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descendre d'Une Ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Zeile nach unten rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di una riga verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Спуститесь на одну строку вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajar una línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行下に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक पंक्ति नीचे जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desça uma linha")
	return /** @type {LocalizedString} */ ("Move Down One Line")
});